module.exports = function getResource(label, vars = []) {
    const resources = { tierCelebrationGift: 'Tier Celebration Gift' };

    return resources[label];
};
